var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "device-setting-audio-test-component" }, [
    _c("div", { staticClass: "device-setting-audio-test" }, [
      _c(
        "div",
        {
          staticClass: "device-set-test",
          attrs: { "data-record-state": "ready" },
        },
        [
          _c("div", { staticClass: "device-set-test-header" }, [
            _c("div", { staticClass: "device-set-test-title-wrapper" }, [
              _c("p", { staticClass: "device-set-test-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("deviceSetting.preview.micNspeaker.test"))
                ),
              ]),
            ]),
            _c("div", { staticClass: "device-set-test-confirm-btn-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "device-set-test-confirm-btn",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onToggleAudioTest")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.complete")))]
              ),
            ]),
          ]),
          _c("div", { staticClass: "device-set-test-body" }, [
            _c("div", { staticClass: "device-set-test-record" }, [
              _c("div", { staticClass: "device-set-test-record-header" }, [
                _vm.recordState === "play" || _vm.recordState === "pause"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "device-set-test-record-complete-container",
                      },
                      [
                        _c("div", {
                          staticClass: "device-set-test-record-complete-mark",
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "device-set-test-record-complete-text-wrapper",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "device-set-test-record-text complete",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "deviceSetting.audioTest.recode.complete"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "device-set-test-record-text-container" },
                  [
                    _c(
                      "p",
                      { staticClass: "device-set-test-record-text title" },
                      [_vm._v(_vm._s(_vm.recordTitle))]
                    ),
                    _vm.recordState === "ready" ||
                    _vm.recordState === "recording" ||
                    _vm.recordState === "end"
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "device-set-test-record-text description",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("deviceSetting.audioTest.recode.maxTime")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _c("div", { staticClass: "device-set-test-record-body" }, [
                _c("div", { staticClass: "device-set-test-record-voice" }),
                _vm.recordState === "ready" ||
                _vm.recordState === "recording" ||
                _vm.recordState === "end"
                  ? _c(
                      "p",
                      { staticClass: "device-set-test-record-text time" },
                      [_vm._v(" " + _vm._s(this.recordDurationTime))]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.recordState === "play" ||
                          _vm.recordState === "pause",
                        expression:
                          "recordState === 'play' || recordState === 'pause' ",
                      },
                    ],
                    staticClass: "device-set-test-record-bar-container",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "device-set-test-record-bar-wrapper" },
                      [
                        _c("input", {
                          ref: "recordBar",
                          staticClass: "device-set-test-record-bar",
                          style: _vm.recordBarStyle,
                          attrs: {
                            type: "range",
                            min: "0",
                            value: "0",
                            step: "0.001",
                          },
                          on: { input: _vm.onSlideRecordBar },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "device-set-test-record-info-container" },
                      [
                        _c(
                          "p",
                          { staticClass: "device-set-test-record-info-time" },
                          [_vm._v(_vm._s(_vm.recordCurrentTime))]
                        ),
                        _c(
                          "p",
                          { staticClass: "device-set-test-record-info-time" },
                          [_vm._v(_vm._s(_vm.recordDurationTime))]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("audio", {
                  ref: "recordAudio",
                  staticStyle: { display: "none" },
                  attrs: { controls: "", src: _vm.blobUrl },
                  on: {
                    durationchange: _vm.onDurationChange,
                    timeupdate: _vm.onTimeUpdate,
                    ended: _vm.onEnded,
                  },
                }),
              ]),
              _c("div", { staticClass: "device-set-test-record-footer" }, [
                _c(
                  "div",
                  { staticClass: "device-set-test-record-btn-container" },
                  [
                    _vm.recordState === "ready"
                      ? _c(
                          "button",
                          {
                            staticClass: "device-set-test-record-btn record",
                            on: {
                              click: function ($event) {
                                return _vm.onRecord("recording")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("deviceSetting.audioTest.recode.start")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.recordState === "recording"
                      ? _c(
                          "button",
                          {
                            staticClass: "device-set-test-record-btn end",
                            on: {
                              click: function ($event) {
                                return _vm.onRecord("end")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("deviceSetting.audioTest.recode.stop")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.recordState === "end"
                      ? _c(
                          "button",
                          {
                            staticClass: "device-set-test-record-btn end",
                            staticStyle: { "pointer-events": "none" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "deviceSetting.audioTest.recode.fileCreate"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.recordState === "pause"
                      ? _c(
                          "button",
                          {
                            staticClass: "device-set-test-record-btn play",
                            on: {
                              click: function ($event) {
                                return _vm.onRecord("play")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("deviceSetting.audioTest.play"))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.recordState === "play"
                      ? _c(
                          "button",
                          {
                            staticClass: "device-set-test-record-btn pause",
                            on: {
                              click: function ($event) {
                                return _vm.onRecord("pause")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("deviceSetting.audioTest.pause"))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.recordState === "play" || _vm.recordState === "pause"
                      ? _c(
                          "button",
                          {
                            staticClass: "device-set-test-record-btn re-record",
                            on: {
                              click: function ($event) {
                                return _vm.onRecord("ready")
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("deviceSetting.audioTest.recode.again")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "device-set-test-footer" }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }